import React from "react";
import "./SoftwareSolutionsSection6.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SoftwareSolutionsSection6 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="pricing-section">
      {/* Left Side - Text & Buttons */}
      <article className="pricing-info">
        <header>
          <h2>{t("softwareSolutions.softwareSolutions6.heading")}</h2>
        </header>
        <p>{t("softwareSolutions.softwareSolutions6.paragraph")}</p>
        <div className="pricing-buttons">
          <Link to={`/${lang}/ContactUs`} onClick={scrollToTop} className="cta">
            <button className="secondary-btn">
              {t("softwareSolutions.softwareSolutions6.button")}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ background: "rgba(0, 0, 0, 0)" }}
              />
            </button>
          </Link>
        </div>
      </article>

      {/* Right Side - Pricing Cards */}
      <div className="pricing-cards">
        <article className="card-software mini">
          <header>
            <h2>{t("softwareSolutions.softwareSolutions6.heading2")}</h2>
          </header>
          <p>{t("softwareSolutions.softwareSolutions6.paragraph2")}</p>
          <ul>
            <li>{t("softwareSolutions.softwareSolutions6.li1")}</li>
            <li>{t("softwareSolutions.softwareSolutions6.li2")}</li>
            <li>{t("softwareSolutions.softwareSolutions6.li3")}</li>
          </ul>
          <Link to={`/${lang}/Pricing/Software`} onClick={scrollToTop}>
            <button className="see-pricing blue">
              {t("softwareSolutions.softwareSolutions6.button2")}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ background: "rgba(0, 0, 0, 0)" }}
              />
            </button>
          </Link>
        </article>

        <article className="card-software basic">
          <header>
            <h2>{t("softwareSolutions.softwareSolutions6.heading3")}</h2>
          </header>
          <p>{t("softwareSolutions.softwareSolutions6.paragraph4")}</p>
          <ul>
            <li>{t("softwareSolutions.softwareSolutions6.li4")}</li>
            <li>{t("softwareSolutions.softwareSolutions6.li5")}</li>
          </ul>
          <Link to={`/${lang}/Pricing/Software`} onClick={scrollToTop}>
            <button className="see-pricing gray">
              {t("softwareSolutions.softwareSolutions6.button2")}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ background: "rgba(0, 0, 0, 0)" }}
              />
            </button>
          </Link>
        </article>
      </div>
    </section>
  );
};

export default SoftwareSolutionsSection6;
